<template>
  <div>
    <b-alert v-if="isImpersonating" variant="warning" show class="mb-0 pb-0 mt-4 pt-4 text-center">
      <strong>IMPERSONATION ACTIVE:</strong> You are currently impersonating another user.
      <b-button @click="stopImpersonating" variant="danger" size="sm" class="ml-2">Stop Impersonating</b-button>
    </b-alert>
    <nav class="navbar navbar-expand-lg navbar-dark" @click="closeNav">
      <div class="container-fluid">
        <router-link to="/home" class="navbar-brand d-flex align-items-center">
          <img src="@/assets/ModelFusionIcon.png" alt="ModelFusion Logo" class="navbar-logo" />
          Model Fusion
        </router-link>
        <button class="navbar-toggler" type="button" @click.stop="toggleNavbar">
          <span class="h6 m-0 navbar-toggler-icon"></span>
        </button>
        <div :class="['collapse', 'navbar-collapse', { show: isNavbarOpen }]" id="navbarContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li v-if="showPricing" class="nav-item">
              <router-link to="/pricing" class="nav-link">Pricing</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/chat" class="nav-link">MultiChat</router-link>
            </li>
            <li v-if="isAuthenticated" class="nav-item">
              <router-link to="/projects" class="nav-link">Documents</router-link>
            </li>
            <li v-if="isAuthenticated" class="nav-item">
              <router-link to="/image" class="nav-link">Generate Images</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/token-calculator" class="nav-link">Token Calculator</router-link>
            </li>
            <b-nav-item v-if="isAdmin" to="/admin">Utilities</b-nav-item>
          </ul>
          <ul class="navbar-nav ml-auto">
            <!-- <li class="nav-item">
              <router-link to="/docs" class="nav-link">Docs</router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/blog" class="nav-link">Blog</router-link>
            </li>
            <template v-if="isAuthenticated">
              <li class="nav-item">
                <router-link to="/feedback" class="nav-link">Feedback</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/profile" class="nav-link">Profile</router-link>
              </li>
              <li v-if="isImpersonating" class="nav-item">
                <b-button @click="stopImpersonating" variant="danger" size="sm" class="ml-2">Stop Impersonating</b-button>
              </li>
              <li class="nav-item">
                <button class="btn btn-primary ml-1" @click="signOut">Sign Out</button>
              </li>
            </template>
            <template v-else>
              <li class="nav-item">
                <b-nav-item @click="showLogin">Log in</b-nav-item>
              </li>
              <li class="nav-item">
                <button class="try-for-free-btn ml-1" @click="tryForFree">Try for Free</button>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    data() {
      return {
        isNavbarOpen: false,
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.isAuthenticated;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      showPricing() {
        if (this.$store.state.user === null) {
          return true;
        }
        return !this.$store.state.user.stripeId;
      },
      isImpersonating() {
        return this.$store.getters.isImpersonating;
      },
    },
    methods: {
      closeNav() {
        console.log('clic');
        this.isNavbarOpen = false;
      },
      signOut() {
        this.$store.dispatch('signOut');
        if (this.$route.path !== '/home') {
          this.$router.push({ path: '/home', query: this.$route.query });
        }
      },
      showLogin() {
        this.$root.$emit('show-login-modal', { canDismiss: true });
        this.isNavbarOpen = false;
      },
      tryForFree() {
        this.$root.$emit('show-signup-modal', { canDismiss: true });
        this.isNavbarOpen = false;
      },
      toggleNavbar() {
        this.isNavbarOpen = !this.isNavbarOpen;
      },
      async stopImpersonating() {
        try {
          const originalUser = JSON.parse(localStorage.getItem('originalAdminUser'));

          if (originalUser) {
            this.$store.commit('setUser', originalUser);
            localStorage.setItem('user', JSON.stringify(originalUser));
            this.$router.push('/admin/users');
          } else {
            await this.signOut();
          }

          this.$bvToast.toast('Impersonation ended', {
            title: 'Impersonation',
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-bottom-right',
            appendToast: true,
          });
        } catch (error) {
          console.error('Error stopping impersonation:', error);
          this.$bvToast.toast('Failed to stop impersonation. Please try again.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-right',
            appendToast: true,
          });
        }
      },
    },
    mounted() {
      this.$store.dispatch('tryAutoSignIn');
    },
  };
</script>

<style scoped>
  .navbar {
    background-color: #003366;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    height: 60px;
    display: flex;
    align-items: center;
    margin-top: 0;
  }

  .container-fluid {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .nav-link {
    color: white !important;
  }

  .navbar-logo {
    width: 3rem;
    height: auto;
    margin-right: 0.5rem;
  }

  .try-for-free-btn {
    background-color: #373cb3;
    color: white !important;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: bold;
    transition: all 0.3s ease;
  }

  .try-for-free-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  .nav-link:hover:not(.try-for-free-btn) {
    background-color: #373cb3;
    border-radius: 20px;
    transition: all 0.3s ease;
  }

  .alert-warning {
    font-size: 1.1em;
    padding: 0.5rem 1rem;
  }

  .alert-warning .btn-danger {
    font-weight: bold;
  }

  @media (max-width: 991.98px) {
    .navbar {
      background-color: #003366;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10000;
      height: 60px;
      display: flex;
      align-items: center;
    }

    .navbar-collapse {
      position: fixed;
      top: 56px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #003366;
      padding: 1rem;
      z-index: 10001;
      overflow-y: auto;
      transition: transform 0.3s ease-in-out;
      transform: translateX(-100%);
    }

    .navbar-collapse.show {
      transform: translateX(0);
    }

    .navbar-nav {
      flex-direction: column;
    }

    .navbar-nav .nav-item {
      text-align: center;
      margin: 0.5rem 0;
    }
  }
</style>
